module.exports = __webpack_public_path__ + "img/hot.e3c42488.png";